var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0003({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-tab",
    id: "Shape",
    d: "M14.2,15H10.045a.4.4,0,0,1-.4-.4V13.259a.4.4,0,0,1,.4-.4h2.813V10.045a.4.4,0,0,1,.4-.4H14.6a.4.4,0,0,1,.4.4V14.2A.8.8,0,0,1,14.2,15ZM4.955,15H.8a.8.8,0,0,1-.8-.8V10.045a.4.4,0,0,1,.4-.4h1.34a.4.4,0,0,1,.4.4v2.813H4.955a.4.4,0,0,1,.4.4V14.6A.4.4,0,0,1,4.955,15ZM14.6,5.357H13.259a.4.4,0,0,1-.4-.4V2.143H10.045a.4.4,0,0,1-.4-.4V.4a.4.4,0,0,1,.4-.4H14.2a.8.8,0,0,1,.8.8V4.955A.4.4,0,0,1,14.6,5.357Zm-12.857,0H.4a.4.4,0,0,1-.4-.4V.8A.8.8,0,0,1,.8,0H4.955a.4.4,0,0,1,.4.4v1.34a.4.4,0,0,1-.4.4H2.143V4.955A.4.4,0,0,1,1.742,5.357Z",
    fill: "#738490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0003);
export default __webpack_public_path__ + "static/media/0003.33ebe3461509314a3e8fa7d021d0a721.svg";
export { ForwardRef as ReactComponent };